export const salePurchaseMenus = [
    // { title: '上架总览', key: '/sale/pur/sjzl',icon:'icon iconfont icon-r', },
    { title: '我的收藏', key: '/sale/pur/collect',icon:'icon iconfont icon-wodeshoucang', },
    { title: '采购车', key: '/sale/pur/cgc',icon:'icon iconfont icon-chaoshi', },
    { title: '采购订单', key: '/sale/pur/cgdd',icon:'icon iconfont icon-qianyue-sjcs' },

];